import React, { useState } from 'react';
import { CLARITY_CONSENT_KEY, isClarityConfigured, startClarity, stopClarityAfterWithdrawal } from '../utils/clarity';
import '../styles/analyticsConsent.css';

function readConsent() {
  try {
    const value = window.localStorage.getItem(CLARITY_CONSENT_KEY);
    return value === 'accepted' || value === 'declined' ? value : null;
  } catch {
    return null;
  }
}

function AnalyticsConsent({ enabled = isClarityConfigured() }) {
  const [choice, setChoice] = useState(readConsent);
  const [open, setOpen] = useState(choice === null);
  const [error, setError] = useState('');

  if (!enabled) return null;

  const saveChoice = (nextChoice) => {
    try {
      window.localStorage.setItem(CLARITY_CONSENT_KEY, nextChoice);
    } catch {
      setError('Your browser could not save this choice. Analytics remains off.');
      return;
    }

    setError('');
    setChoice(nextChoice);
    setOpen(false);

    if (nextChoice === 'accepted') {
      startClarity();
    } else if (choice === 'accepted') {
      stopClarityAfterWithdrawal();
    }
  };

  return (
    <div className="analytics-consent" data-clarity-mask="true">
      {open ? (
        <section className="analytics-consent-panel" aria-label="Analytics preferences">
          <h2>Optional analytics</h2>
          <p>
            With your permission, Microsoft Clarity records how you use this web portal,
            including clicks and session replay, to help us improve it. Your choice does
            not affect access to the portal. Read our <a href="/privacy-policy">Privacy Policy</a>.
          </p>
          {choice && <p className="analytics-consent-status">Current choice: {choice === 'accepted' ? 'On' : 'Off'}</p>}
          {error && <p className="analytics-consent-error" role="alert">{error}</p>}
          <div className="analytics-consent-actions">
            <button type="button" className="analytics-consent-decline" onClick={() => saveChoice('declined')}>
              Decline analytics
            </button>
            <button type="button" className="analytics-consent-accept" onClick={() => saveChoice('accepted')}>
              Accept analytics
            </button>
            {choice && (
              <button type="button" className="analytics-consent-cancel" onClick={() => setOpen(false)}>
                Close
              </button>
            )}
          </div>
        </section>
      ) : (
        <button type="button" className="analytics-consent-trigger" onClick={() => setOpen(true)}>
          Analytics preferences
        </button>
      )}
    </div>
  );
}

export default AnalyticsConsent;
